import MuiButton from '@mui/material/Button';
import clsx from 'clsx';
import type { ComponentProps } from 'react';

export const Button = (props: ComponentProps<typeof MuiButton>) => {
  return (
    <MuiButton
      {...props}
      className={clsx(props.className)}
      sx={{ borderRadius: '99px', padding: '8px 24px' }}
    />
  );
};
